import React, { useState, useEffect } from 'react';
import {
  RotateBar,
  RotateIconButton,
  RotateAngleField,
  RotateAngleInput,
  RotateBarDivider,
  CropActionButton,
} from '../imageCanvasStyles';

const RotateOverlay = ({ theme, selectedTheme, imgRef, angle, onAngleChange, onApply, onCancel }) => {
  const shared = { theme, $selectedTheme: selectedTheme };
  const [ inputValue, setInputValue ] = useState(String(angle));

  useEffect(() => {
    setInputValue(String(angle));
  }, [ angle ]);

  const handleLeft = () => onAngleChange(angle - 90);
  const handleRight = () => onAngleChange(angle + 90);

  const handleInputChange = e => {
    const raw = e.target.value;
    setInputValue(raw);
    if (raw === '' || raw === '-') return;
    const parsed = Number(raw);
    if (!Number.isNaN(parsed)) onAngleChange(parsed);
  };

  const handleInputBlur = () => {
    if (inputValue === '' || inputValue === '-') {
      setInputValue(String(angle));
    }
  };

  const handleApply = () => {
    const img = imgRef?.current;
    if (!img) return;

    const w = img.naturalWidth;
    const h = img.naturalHeight;
    const rad = (angle * Math.PI) / 180;
    const sinA = Math.abs(Math.sin(rad));
    const cosA = Math.abs(Math.cos(rad));
    const cw = Math.round(w * cosA + h * sinA);
    const ch = Math.round(w * sinA + h * cosA);

    const canvas = document.createElement('canvas');
    canvas.width = cw;
    canvas.height = ch;
    const ctx = canvas.getContext('2d');
    ctx.translate(cw / 2, ch / 2);
    ctx.rotate(rad);
    ctx.drawImage(img, -w / 2, -h / 2);
    onApply(canvas.toDataURL('image/png'));
  };

  return (
    <RotateBar {...shared}>
      <RotateIconButton {...shared} onClick={handleLeft} title='Rotate left 90°'>
        <span>&#8634;</span> 90&deg;
      </RotateIconButton>
      <RotateIconButton {...shared} onClick={handleRight} title='Rotate right 90°'>
        <span>&#8635;</span> 90&deg;
      </RotateIconButton>
      <RotateAngleField {...shared}>
        <RotateAngleInput
          {...shared}
          type='number'
          step='1'
          value={inputValue}
          onChange={handleInputChange}
          onBlur={handleInputBlur}
          aria-label='Custom rotation angle in degrees'
        />
        <span>&deg;</span>
      </RotateAngleField>
      <RotateBarDivider {...shared} />
      <CropActionButton onClick={onCancel}>Cancel</CropActionButton>
      <CropActionButton $primary onClick={handleApply}>Apply</CropActionButton>
    </RotateBar>
  );
};

export { RotateOverlay };
